/**
 * @fileOverview Spacing used in .js and .jsx files need to be standardized
 * using the values contained in this file.
 *
 * PLEASE TO NOT ADD TO OR CHANGE VALUES IN THIS FILE WITHOUT SPEAKING TO THE
 * LEAD ON INTERFACE DESIGN.
 */

export const SPACE_MD = "16px";
export const SPACE_SM = "12px";
export const SPACE_XS = "8px";
export const SPACE_LG = "24px";
